// extracted by mini-css-extract-plugin
export var aircallIframe = "_n1-3";
export var fabContainer = "_n1-5";
export var fabRinging = "_n1-6";
export var loadingOverlay = "_n1-4";
export var pulse = "_n1-7";
export var widgetContent = "_n1-2";
export var widgetPanel = "_n1-0";
export var widgetPanelExpanded = "_n1-1";